import React from 'react'
import HighValueSettings from '../Components/HighValueSetting'
import './styles/modern-pages.css'
import './styles/settings.css'

export default function Settings() {
  return (
    <div className='modern-page settings-body'>
      <div className='modern-page-shell'>
        <header className='modern-page-header'>
          <h1 className='modern-page-title'>Settings</h1>
        </header>
        <div className='settings-cards'>
          <HighValueSettings />
        </div>
      </div>
    </div>
  )
}
